module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.multi) ? _c('AppComboboxSingle', {
    staticClass: "root_combobox",
    style: (_vm.getStyle),
    attrs: {
      "data": _vm.data,
      "value": _vm.value,
      "disabled": _vm.disabled,
      "is-enable-sort": _vm.isEnableSort,
      "placeholder": _vm.placeholder,
      "filterable": _vm.filterable,
      "notEmpty": _vm.notEmpty,
      "error": _vm.error,
      "valid": _vm.valid,
      "check-form": _vm.checkForm
    },
    on: {
      "input": _vm.selectData,
      "validate": _vm.validate
    }
  }) : (_vm.multi) ? _c('AppComboboxMulti', {
    staticClass: "root_combobox",
    class: {
      disabled: _vm.disabled
    },
    style: (_vm.getStyle),
    attrs: {
      "data": _vm.data,
      "is-enable-sort": _vm.isEnableSort,
      "value": _vm.value,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "filterable": _vm.filterable
    },
    on: {
      "input": _vm.selectData
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f63b568","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppComboBox/AppComboBox.vue
// module id = 8a307567c15239c9fff4
// module chunks = 0